/* T8 image protection: no "Save image as…" menu, no drag-to-desktop and no long-press save on the site's images
   (product photos, artwork, lifestyle shots). Form fields and links keep their normal menus. */
(function () {
  'use strict';
  function isImg(t) { return t && (t.tagName === 'IMG' || t.tagName === 'PICTURE' || t.tagName === 'VIDEO' || (t.closest && t.closest('picture, .t8-pf__stage, .t8-gal__stage'))); }
  document.addEventListener('contextmenu', function (e) { if (isImg(e.target)) e.preventDefault(); });
  document.addEventListener('dragstart', function (e) { if (e.target && e.target.tagName === 'IMG') e.preventDefault(); });
})();
